/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */

import { useState } from 'react';
import { Button } from 'reactstrap';
import { MetricSubmitData } from '../../types/custom-report';
import { apiClient } from '../../actions/api';
import CreateMetricForm from '../create-metric-form/CreateMetricForm';

interface Props {
  initiativeId: string;
  handleReload?: () => Promise<void>;
  onCancel?: () => void;
}

const CustomTarget = (props: Props) => {
  const {
    initiativeId,
    handleReload,
    onCancel,
  } = props;

  const [data, setData] = useState<MetricSubmitData | undefined>(undefined);

  const handleSubmit = async () => {
    if (!data) {
      return;
    }

    await apiClient.createCalculationUtr(initiativeId, data);
    if (handleReload) {
      await handleReload();
    }
    if (onCancel) {
      onCancel();
    }
  }

  return (
    <>
      <CreateMetricForm
        initiativeId={initiativeId}
        handleUpdate={setData}
       />
      <div className='text-right mt-3'>
        {onCancel ? <Button color='link-secondary' onClick={onCancel}>Cancel</Button> : null}
        <Button color='primary' disabled={!data} className='ml-3' onClick={handleSubmit}>Save</Button>
      </div>
    </>
  );
}

export default CustomTarget;
